export const INELIGIBLE_URL = 'sorrywecantsellyourvehicle';
export const DAYS_TO_EXPIRE_ENQUIRY = 7;
